import hres92uLabels from 'assets/labels/hres92u'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres92uLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        id: i,
        codempid: faker.lorem.words(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number(),
        dteyear: moment().format('DD/MM/YYYY'),
        numclseq: faker.random.number(),
        desc_codcours: faker.name.findName(),
        desc_codtparg: faker.name.findName(),
        staappr: '',
        status: mockStatus[staappr],
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remark: faker.lorem.words(),
        desc_codempap: faker.name.findName(),
        approvno: faker.random.number().toString().substr(0, 1),
        chk_appr: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codinput: faker.lorem.words(),
      desc_codinput: faker.name.findName(),
      codempid: faker.lorem.words(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      dteyear: moment().format('YYYY'),
      numclseq: faker.random.number(),
      codcours: faker.lorem.words(),
      desc_codcours: faker.lorem.word(),
      dtetrst: moment().format('DD/MM/YYYY'),
      dtetren: moment().format('DD/MM/YYYY'),
      qtytrmin: faker.random.number(),
      desc_codinsts: faker.lorem.word(),
      desc_codhotel: faker.lorem.word(),
      desc_codinst: faker.name.findName(),
      desreq: faker.lorem.word()
    }

    return {
      tab1: mockTab1
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres92u/mocker.js